import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiAppointments, apiGroupAppointments, apiWeeklyPlanner } from '~constants/api';

import { download, get, patch, post, put } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'appointments';

interface DownloadParams extends Params {
  onProgress: (value: string) => void;
}

const config = [
  { actionType: 'getAll', apiPath: apiAppointments, method: get },
  { actionType: 'getSignature', apiPath: (params: Params) => `${apiAppointments}/${params.id}/signature`, method: get },
  { actionType: 'create', apiPath: apiAppointments, method: post },
  { actionType: 'bulkUpdate', apiPath: apiAppointments, method: put },
  { actionType: 'update', apiPath: (params: Params) => `${apiAppointments}/${params.id}`, method: put },
  {
    actionType: 'addGroupChildren',
    apiPath: (params: Params) => `${apiGroupAppointments}/${params.id}/children`,
    method: post,
  },
  {
    actionType: 'acknowledge',
    apiPath: (params: Params) => `${apiAppointments}/${params.id}/acknowledge`,
    method: patch,
  },
  { actionType: 'cancel', apiPath: (params: Params) => `${apiAppointments}/${params.id}/cancel`, method: post },
  { actionType: 'getEstimate', apiPath: `${apiAppointments}/estimate`, method: get },
  {
    actionType: 'startBidding',
    apiPath: `${apiAppointments}/bidding/start`,
    method: post,
  },
  {
    actionType: 'endBidding',
    apiPath: (params: Params) => `${apiAppointments}/${params.id}/bidding/end`,
    method: post,
  },
  { actionType: 'getStatistics', apiPath: `${apiWeeklyPlanner}/statistics`, method: get },
  { actionType: 'acceptAll', apiPath: `${apiAppointments}/accept`, method: post },
  { actionType: 'emailAll', apiPath: `${apiAppointments}/email`, method: post },
  { actionType: 'notifyUser', apiPath: (params: Params) => `${apiAppointments}/${params.id}/notify`, method: post },
];

export const {
  getAll,
  getSignature,
  create,
  bulkUpdate,
  update,
  addGroupChildren,
  acknowledge,
  cancel,
  startBidding,
  endBidding,
  getStatistics,
  emailAll,
  acceptAll,
  notifyUser,
  getEstimate,
} = createThunks(typePrefix, config);

// handle separately due to extra params
export const exportAll = async ({ onProgress, params }: DownloadParams) =>
  download(`${apiAppointments}/export`, params, onProgress);

export const getOne = createAsyncThunk(
  `${typePrefix}/getOne`,
  async ({ isTemplate, isParent, isChild, ...params }: Params) => {
    const response = await get(`${apiAppointments}/${params.id}`, params);
    return { ...response, isTemplate, isParent, isChild };
  },
);
